/**
 * Angular Packages
 */
import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HttpClientModule} from '@angular/common/http';
import { NgxCaptchaModule } from 'ngx-captcha';
import {NgxMaskModule} from 'ngx-mask';
import { CurrencyMaskModule } from "ng2-currency-mask";

/**
 * Custom Items
 */
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {LandingComponent} from './pages/landing/landing.component';
import {ApplicationFormComponent} from './pages/application-form/application-form.component';
import {HeaderComponent} from './components/header/header.component';
import {SplashCardComponent} from './components/splash-card/splash-card.component';
import {ConfirmationComponent} from './pages/confirmation/confirmation.component';
import { DocumentUploadComponent } from './components/document-upload/document-upload.component';

import { NumberDirective } from '../app/shared/numbers-only.directive';

/**
 * 3rd Party Packagess
 */
import {ClarityModule} from '@clr/angular';
import { TermsComponent } from './terms/terms.component';
import { CustomerComponent } from './pages/customer/customer.component';
import { ReviewComponent } from './pages/review/review.component';
import { UploadSuccessComponent } from './pages/upload-success/upload-success.component';



@NgModule({
  declarations: [
    AppComponent,
    LandingComponent,
    ApplicationFormComponent,
    HeaderComponent,
    SplashCardComponent,
    ConfirmationComponent,
    TermsComponent,
    CustomerComponent,
    ReviewComponent,
    DocumentUploadComponent,
    NumberDirective,
    UploadSuccessComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ClarityModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    NgxCaptchaModule,
    NgxMaskModule.forRoot(),
    CurrencyMaskModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}
